{
  "nl": {
    "gallery": {
      "headers": {
        "title": "Vind kant-en-klaar lesmateriaal als OER"
      }
    }
  }
}
